import React from 'react';

import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const FormContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.formContainer, style] });

type LabelContainerProps = BoxProps & { $alignItems?: ViewStyle['alignItems'] };

export const LabelContainer = ({ $alignItems, style, ...props }: LabelContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.labelContainer, { alignItems: $alignItems || 'center' }, style],
  });

const styles = StyleSheet.create({
  formContainer: {
    marginHorizontal: spacing.$2,
    marginTop: spacing.$2,
  },
  labelContainer: {
    flex: 1,
    marginLeft: spacing.$3,
  },
});
